(() => {
  if (customElements.get('ecom-billing')) return;
  const keys = ['_billing_rut', '_billing_company_name', '_billing_business_activity'];
  let draft, saving = false, lastCartEdit = 0;
  for (const eventName of ['input', 'change']) document.addEventListener(eventName, event => {
    if (event.target.matches('[name="updates[]"], [name="note"]')) lastCartEdit = Date.now();
  }, true);
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    saving = false;
    document.querySelectorAll('ecom-billing').forEach(element => {
      element.querySelector('fieldset').disabled = false;
      element.querySelector('[data-continue]').textContent = 'Continuar al pago';
    });
  });
  class EcomBilling extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.choice = this.querySelector('[data-invoice]');
      this.fields = this.querySelector('[data-fields]');
      this.inputs = keys.map(key => this.querySelector('[data-key="' + key + '"]'));
      this.button = this.querySelector('[data-continue]');
      this.error = this.querySelector('[data-error]');
      if (draft) {
        this.choice.checked = draft.invoice;
        this.inputs.forEach((input, i) => input.value = draft.values[i]);
      } else this.choice.checked = this.inputs.some(input => input.value.trim());
      const remember = () => {
        draft = { invoice: this.choice.checked, values: this.inputs.map(input => input.value) };
        this.fields.hidden = !this.choice.checked;
        this.inputs.forEach(input => {
          input.required = this.choice.checked;
          input.disabled = !this.choice.checked;
          input.setCustomValidity('');
        });
        this.error.textContent = '';
      };
      this.addEventListener('input', remember);
      this.choice.addEventListener('change', remember);
      this.button.addEventListener('click', () => this.checkout());
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('[data-key]')) {
          event.preventDefault(); this.checkout();
        }
      });
      remember();
      this.button.disabled = saving;
    }
    async checkout(discount) {
      if (saving) return;
      this.error.textContent = '';
      const values = this.inputs.map(input => input.value.trim());
      if (this.choice.checked) {
        for (let i = 0; i < this.inputs.length; i++) {
          this.inputs[i].setCustomValidity(values[i] ? '' : 'Completa este campo para solicitar factura.');
          if (!this.inputs[i].reportValidity()) return;
        }
        const rut = values[0].toUpperCase();
        const valid = /^(?:\d{7,8}|\d{1,2}\.\d{3}\.\d{3})-[\dK]$/.test(rut);
        this.inputs[0].setCustomValidity(valid ? '' : 'Ingresa un RUT como 12.345.678-5 o 12345678-5.');
        if (!this.inputs[0].reportValidity()) return;
        values[0] = rut.replace(/\./g, '');
      }
      const attributes = Object.fromEntries(keys.map((key, i) => [key, this.choice.checked ? values[i] : '']));
      const root = this.dataset.root.replace(/\/?$/, '/');
      const quantities = Array.from(document.querySelectorAll('#cart input[name="updates[]"]'));
      for (const input of quantities) {
        if (!input.reportValidity()) return;
        if (input.value !== input.defaultValue) input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      saving = true;
      this.querySelector('fieldset').disabled = true;
      this.button.textContent = 'Guardando datos…';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      let navigating = false;
      try {
        // Shrine debounces quantity changes. Wait for its requests before updating attributes.
        while (Date.now() - lastCartEdit < 800 || window.ecomCartPending > 0) {
          if (controller.signal.aborted) throw new Error('timeout');
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        if (document.querySelector('.cart-item__error-text:not(:empty)')) throw new Error('quantity');
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes })
        });
        if (!response.ok) throw new Error('save');
        const cart = await response.json();
        const currentQuantities = Array.from(document.querySelectorAll('#cart input[name="updates[]"]'));
        if (currentQuantities.length !== cart.items.length || currentQuantities.some((input, i) => Number(input.value) !== cart.items[i].quantity)) throw new Error('quantity');
        if (!cart.item_count || !keys.every(key => (cart.attributes?.[key] || '') === attributes[key])) throw new Error('verify');
        const code = typeof discount === 'string' ? discount : new URLSearchParams(location.search).get('discount');
        navigating = true;
        location.assign(root + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''));
      } catch (error) {
        this.error.textContent = 'No pudimos confirmar los datos. Revisa el carrito y tu conexión, y vuelve a intentarlo.';
      } finally {
        clearTimeout(timeout);
        if (!navigating) {
          saving = false;
          this.querySelector('fieldset').disabled = false;
          this.button.textContent = 'Continuar al pago';
        }
      }
    }
  }
  customElements.define('ecom-billing', EcomBilling);
  // Guard theme cart submissions, including Enter and notification-cart buttons.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('#cart, #CartDrawer-Form, #cart-notification-form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const billing = document.querySelector('ecom-billing');
    if (billing) billing.checkout();
    else location.assign(window.routes.cart_url);
  }, true);
})();